import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from '@fluentui/react-components';
import { AddRegular, ClipboardTaskListLtr20Regular, Dismiss24Regular } from '@fluentui/react-icons';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import type { TProjectTemplateMock } from '../types';

type TProps = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  templates: TProjectTemplateMock[];
  onCreateBlank: () => void;
  onSelectTemplate: (template: TProjectTemplateMock) => void;
};

const ProjectTemplateDialog = ({ isOpen, setIsOpen, templates, onCreateBlank, onSelectTemplate }: TProps) => (
  <Dialog open={isOpen} onOpenChange={(_, data) => setIsOpen(data.open)}>
    <DialogSurface>
      <DialogBody>
        <DialogTitle
          action={
            <Button
              appearance="subtle"
              aria-label="close"
              icon={<Dismiss24Regular />}
              onClick={() => setIsOpen(false)}
            />
          }
        >
          New {TERMINOLOGY.project.lower}
        </DialogTitle>
        <DialogContent className="max-h-[70vh] overflow-y-auto">
          <div className="flex flex-col gap-2">
            <Button
              className="!justify-start !py-3"
              icon={<AddRegular />}
              onClick={() => {
                setIsOpen(false);
                onCreateBlank();
              }}
            >
              Blank {TERMINOLOGY.project.lower}
            </Button>
            {templates.map((template, index) => (
              <Button
                key={`${template.project}-${index}`}
                className="!justify-start !py-3"
                icon={<ClipboardTaskListLtr20Regular />}
                onClick={() => {
                  setIsOpen(false);
                  onSelectTemplate(template);
                }}
              >
                <span className="min-w-0 break-words text-left">{template.name}</span>
              </Button>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>Cancel</Button>
        </DialogActions>
      </DialogBody>
    </DialogSurface>
  </Dialog>
);

export default ProjectTemplateDialog;
